import { IonCard, IonCardHeader, IonCardTitle } from '@ionic/react';
import { ReactElement } from 'react';
import { Machine } from '../../../api/graphql/generated';
import i18n from '../../../i18n';
import { useBeaconRouter } from '../../../route/route.hooks';

interface EventsCardProps {
  machine?: Machine;
}

const EventsCard = (props: EventsCardProps): ReactElement => {
  const { machine } = props;

  const { builder } = useBeaconRouter();

  return (
    <IonCard
      className="machine-card-container"
      routerLink={
        machine
          ? builder.getMachineEventDefinitionsRoute(machine.teamId, machine.id)
          : undefined
      }
    >
      <IonCardHeader>
        <IonCardTitle>{i18n.t('common:machine_events')}</IonCardTitle>
      </IonCardHeader>
      <p className="card-description">
        {i18n.t('common:event_description_for_card')}
      </p>
    </IonCard>
  );
};

export { EventsCard };
